import React from 'react';
import {
  CardStyleInterpolators,
  createStackNavigator,
} from '@react-navigation/stack';
import {StyleSheet, Text} from 'react-native';
import {makeId} from '../../utils';
import {E_NAVIGATION_DESTINATIONS} from '../../@types';
import {Deliveries, PackageDetails, Packages, PackagesHistory} from './screens';
import {createMaterialTopTabNavigator} from '@react-navigation/material-top-tabs';
import {colorSwatches} from '../../styles';
import {Badge} from 'react-native-paper';

const Stack = createStackNavigator();

const PackageHistoryNavigator = () => {
  const options = {
    headerShown: false,
    cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
  };

  return (
    <Stack.Navigator>
      <Stack.Screen
        name={E_NAVIGATION_DESTINATIONS.PACKAGES_HISTORIES_LIST}
        component={PackagesHistory}
        options={{...options, animationTypeForReplace: 'pop'}}
        key={makeId(12)}
      />
           <Stack.Screen
        name={E_NAVIGATION_DESTINATIONS.PACKAGE_DETAILS}
        component={PackageDetails}
        options={{...options, animationTypeForReplace: 'pop'}}
        key={makeId(12)}
      />
    </Stack.Navigator>
  );
};

const PackagesNavigator = () => {
  const options = {
    headerShown: false,
    cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
  };

  return (
    <Stack.Navigator>
      <Stack.Screen
        name={E_NAVIGATION_DESTINATIONS.PACKAGES}
        component={Packages}
        options={{...options, animationTypeForReplace: 'pop'}}
        key={makeId(12)}
      />
      <Stack.Screen
        name={E_NAVIGATION_DESTINATIONS.PACKAGE_DETAILS}
        component={PackageDetails}
        options={{...options, animationTypeForReplace: 'pop'}}
        key={makeId(12)}
      />
    </Stack.Navigator>
  );
};

const {Navigator, Screen} = createMaterialTopTabNavigator();

export function DeliveriesTabs({
  unclaimedPackagesCount,
  deliveriesCount,
  canViewDeliveries = true,
}) {
  return (
    <Navigator
      screenOptions={{
        tabBarStyle: styles.tabBar,
        tabBarActiveTintColor: '#ffffff',
        tabBarInactiveTintColor: 'rgba(255,255,255,0.85)',
        tabBarIndicatorStyle: styles.indicator,
        tabBarItemStyle: styles.tabItem,
        tabBarLabelStyle: styles.tabLabel,
        lazy: true,
        tabBarScrollEnabled: false,
      }}>
      {canViewDeliveries && (
        <Screen
          name={E_NAVIGATION_DESTINATIONS.DELIVERIES}
          component={Deliveries}
          initialParams={{embedded: true, fetchOnMount: false}}
          options={{
            tabBarLabel: ({focused}) => (
              <Text
                style={[
                  styles.tabLabel,
                  focused ? styles.activeTabLabel : styles.inactiveTabLabel,
                ]}>
                Deliveries
              </Text>
            ),
            tabBarBadge: () =>
              deliveriesCount > 0 ? <Badge>{deliveriesCount}</Badge> : null,
          }}
        />
      )}
      <Screen
        name={E_NAVIGATION_DESTINATIONS.PACKAGES}
        component={Packages}
        options={{
          tabBarLabel: ({focused}) => (
            <Text
              style={[
                styles.tabLabel,
                focused ? styles.activeTabLabel : styles.inactiveTabLabel,
              ]}>
              Packages
            </Text>
          ),
          tabBarBadge: () =>
            unclaimedPackagesCount ? (
              <Badge>{unclaimedPackagesCount}</Badge>
            ) : null,
        }}
      />
    </Navigator>
  );
}

export const packageHistoryScreens = {
  [E_NAVIGATION_DESTINATIONS.PACKAGES_HISTORIES_LIST]: '/packagesHistoryList',
  [E_NAVIGATION_DESTINATIONS.PACKAGE_DETAILS]: '/packageDetails',
};

const styles = StyleSheet.create({
  tabBar: {
    backgroundColor: colorSwatches.primary.color,
  },
  indicator: {
    backgroundColor: '#ffffff',
  },
  tabItem: {
    width: '50%',
  },
  tabLabel: {
    color: '#ffffff',
    fontSize: 14,
    fontWeight: '600',
    textTransform: 'none',
  },
  activeTabLabel: {
    opacity: 1,
  },
  inactiveTabLabel: {
    opacity: 0.85,
  },
});

export default PackageHistoryNavigator;
